"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Measure = void 0;
/**
 * Values of measurements recorded. Fields included would be the value, permissible range (min. and max.), severity, unit of measurement, etc
 */
class Measure {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.Measure = Measure;
//# sourceMappingURL=Measure.js.map